<template lang="pug">
	.ai-music--audio-processing
		DxPopover(:width="300", :shading="false", :target="target", show-event="click", position="top", ref="actionsPopover")
			.ai-music--audio-processing
				a.item.flex-row.space.align-center(v-for="action in actions", @click="processAction(action)")
					fas(v-if="action.icon", :icon="action.icon")
					span {{ action.text }}
		Popup(v-if="fade.visible", :popupVisible.sync="fade.visible", :title="fade.kind === 0 ? $tCaption('Fade in') : $tCaption('Fade out')", :width="320", :autosize="true")
			.flex-col.space-medium
				.flex-col.flex-1
					.font-small.upper.grey {{ $tCaption('Fade type') }}
					DxSelectBox.flex-1(:dataSource="fadeInOutTypes", display-expr="text", value-expr="id", :value.sync="fade.type", :dropDownOptions="dropDownOptions", stylingMode="filled", :disabled="fade.loading")
				DxCheckBox(:text="fade.kind === 0 ? $tCaption('Remove audio before') : $tCaption('Remove audio after')", :value.sync="fade.removeRestAudio")
				Loader(v-if="fade.loading", text="")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Confirm', '@actions')", type="success", @click="processFade", :disabled="fade.loading")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="fade.visible = false", :disabled="fade.loading")
</template>

<script>	
	import audio from 'app-core/audio';
	import Popup from 'app-core/Popup.vue';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import Loader from 'app-core/Loader.vue';
	import { DxPopover } from 'devextreme-vue/popover';

	export default {
		translationCategory: 'aiMusic.AudioProcessing',
		name: 'ai-music--audio-processing',
		components: { Popup, DxNumberBox, DxSelectBox, DxButton, Loader, DxPopover, DxCheckBox },
		props: ['buffer', 'selection', 'target'],
		data() {
			return {
				actions: [
					{ id: 'cut', text: this.$tCaption('Cut'), icon: 'scissors' },
					{ id: 'fadeIn', text: this.$tCaption('Fade in'), icon: 'arrow-right-from-bracket' },
					{ id: 'fadeOut', text: this.$tCaption('Fade out'), icon: 'arrow-right-to-bracket' }
				],
				fade: {
					visible: false,
					kind: 0,
					type: 'exponential',
					value: 0,
					loading: false,
					removeRestAudio: true
				},
				fadeInOutTypes: [
					{ id: 'linear', text: this.$tCaption('Linear') },
					{ id: 'exponential', text: this.$tCaption('Logarithmic') }
				],
				dropDownOptions: { minWidth: '160px' }
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.aiMusicAudioProcessing = this;
		},
		destroyed() {
			
		},
		methods: {
			processAction(action) {
				if (__DEBUG__)
					console.debug('Process action', { action });

				if (this.$refs.actionsPopover?.instance)
					this.$refs.actionsPopover.instance.hide();

				switch(action.id) {
					case 'cut':
						this.$confirm(void 0, this.$tCaption('Cut selected part?')).then(() => {
							this.processCut().then((r) => this.emitResult(r));
						});
						break;
					case 'fadeIn':
						this.showFade(0);
						break;
					case 'fadeOut':
						this.showFade(1);
						break;
				}
			},
			showFade(kind) {
				this.fade.kind = kind;
				this.fade.visible = false;
				this.fade.value = (this.selection.range[1] - this.selection.range[0]) || 0;
				this.fade.removeRestAudio = true;
				this.$nextTick(() => this.fade.visible = true);
			},
			async processCut() {
				let parts = [];

				if (this.selection.range[0] > 0) {
					parts.push([0, this.selection.range[0]]);
				}

				if (this.buffer?.duration - this.selection.range[1] > 0.01) {
					parts.push([this.selection.range[1], this.buffer.duration]);
				}

				if (!parts.length) return;

				let buffers = await Promise.all(parts.map((p) => audio.cut(this.buffer, p[0], p[1])));

				let result = buffers[0];
				if (buffers.length > 1) {
					result = await audio.merge(buffers);
				}

				return result;
			},
			async emitResult(buffer) {
				let blob = await audio.bufferToWave(buffer);

				this.$emit('change', blob, buffer);
			},
			async processFade() {
				let vals = this.fade.kind === 0 ? [0, 1] : [1, 0];
				let buffer = this.buffer;
				try {
					this.fade.loading = true;

					buffer = await audio.fade(buffer, this.selection.range[0], this.selection.range[1], vals[0], vals[1], this.fade.type);

					if (this.fade.removeRestAudio) {
						if (this.fade.kind === 1) {
							buffer = await audio.cut(buffer, 0, this.selection.range[1]);
						} else {
							buffer = await audio.cut(buffer, this.selection.range[0], this.buffer.duration);
						}
					}

					this.emitResult(buffer);
				} finally {
					this.fade.loading = false;
					this.fade.visible = false;
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.ai-music--audio-processing {
		> .item {
			padding: 4px 0px;
			border-bottom: 1px solid #f1f1f1;
			padding-bottom: 10px;
			color: #333;
			transition: 0.3s;

			&:hover {
				border-bottom: 1px solid $base-accent;
				color: $base-accent;
			}
		}
	}
</style>
 